import type { ComponentType } from 'react';
import KycContent from './KycContent';
import PrivacyPolicyContent from './PrivacyPolicyContent';
import ResponsibleGamingContent from './ResponsibleGamingContent';
import RulesRegulationContent from './RulesRegulationContent';
import TermsConditionContent from './TermsConditionContent';

export type LegalPageId =
  | 'privacy-policy'
  | 'terms-condition'
  | 'rules-regulation'
  | 'kyc'
  | 'responsible-gaming';

export interface LegalPageContent {
  Content: ComponentType;
  id: LegalPageId;
  footerLabel: string;
  title: string;
}

export const legalPages: LegalPageContent[] = [
  {
    Content: PrivacyPolicyContent,
    id: 'privacy-policy',
    footerLabel: 'Privacy Policy',
    title: 'Privacy Policy',
  },
  {
    Content: TermsConditionContent,
    id: 'terms-condition',
    footerLabel: 'Terms and Conditions',
    title: 'Terms and Conditions',
  },
  {
    Content: RulesRegulationContent,
    id: 'rules-regulation',
    footerLabel: 'Rules and Regulations',
    title: 'Rules and Regulations',
  },
  {
    Content: KycContent,
    id: 'kyc',
    footerLabel: 'KYC',
    title: 'KYC',
  },
  {
    Content: ResponsibleGamingContent,
    id: 'responsible-gaming',
    footerLabel: 'Responsible Gaming',
    title: 'Responsible Gaming',
  },
];

export const legalPagesByLabel = Object.fromEntries(
  legalPages.map((page) => [page.footerLabel, page])
) as Record<string, LegalPageContent>;
